import CustomFactoryIcon from "../../app/assets/custom-icons/CustomFactoryIcon";
import CustomCalendar from "../../app/assets/custom-icons/CustomCalendar";
import CustomDashboardIcon from "../../app/assets/custom-icons/CustomDashboardIcon";
import CustomDocManagementIcon from "../../app/assets/custom-icons/CustomDocManagementIcon";
import CustomManageUsersIcon from "../../app/assets/custom-icons/CustomManageUsersIcon";
import CustomPaperworkManagementIcon from "../../app/assets/custom-icons/CustomPaperworkManagementIcon";
import CustomStudioManagementIcon from "../../app/assets/custom-icons/CustomStudioManagementIcon";
import CustomStudioServicesIcons from "../../app/assets/custom-icons/CustomStudioServicesIcons";
import DashboardPage from "../../features/common/DashboardPage/DashboardPage";
import CaricaDocumentiPage from "../../features/admin/CaricaDocumentiPage/CaricaDocumentiPage";
import CreaUtentePage from "../../features/admin/CreaUtentePage/CreaUtentePage";
import GestioneDocumentiPage2 from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiPage2";
import GestisciCommercialistiPage from "../../features/admin/GestisciCommercialistiPage/GestisciCommercialistiPage";
import SchedaCommercialista from "../../features/admin/GestisciCommercialistiPage/SchedaCommercialista";
import GestisciPratichePage from "../../features/admin/GestisciPratichePage/GestisciPratichePage";
import DocumentiPage from "../../features/admin/GestisciPratichePage/SinglePraticaPage/DocumentiPage";
import SinglePraticaPage from "../../features/admin/GestisciPratichePage/SinglePraticaPage/SinglePraticaPage";
import GestisciStudioPage from "../../features/admin/GestisciStudioPage/GestisciStudioPage";
import SchedaStudio from "../../features/admin/GestisciStudioPage/SchedaStudio";
import GestisciUtentiPage from "../../features/admin/GestisciUtentiPage/GestisciUtentiPage";
import NotifichePage from "../../features/common/NotifichePage/NotifichePage";
import ServiziPage from "../../features/admin/ServiziPage/ServiziPage";
import AssistenzaPage from "../../features/business/AssistenzaPage/AssistenzaPage";
import { FormCompany } from "../../features/common/FormCompany/FormCompany";
import GestioneCompany from "../../features/common/FormCompany/GestioneCompany";
import SchedaCompany from "../../features/common/FormCompany/SchedaCompany";
import CreaStudio from "../../features/admin/GestisciStudioPage/CreaStudio";
import GestioneNews from "../../features/common/GestisciNews/GestioneNews";
import CustomNewsIcon from "../../app/assets/custom-icons/CustomNewsIcon";
import CreaNews from "../../features/common/GestisciNews/CreaNews/CreaNews";
import i18n from "../../../public/i18n";
import NewsPage from "../../features/common/NewsPage/NewsPage";
import CustomOperatorIcon from "../../app/assets/custom-icons/CustomOperatorIcon";
import CustomInbox from "../../app/assets/custom-icons/CustomInbox";
import ExtendDocCategoriesPage from "../../features/admin/ExtendDocCategories/ExtendDocCategoriesPage";
import CustomCategory from "../../app/assets/custom-icons/CustomCategory";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ModificaProfiloPage from "../../features/admin/ModificaProfiloPage/ModificaProfiloPage";
import ChatPage from "../../features/common/ChatPage/ChatPage";
import PrivacyTipRoundedIcon from "@mui/icons-material/PrivacyTipRounded";
import TerminiCondizioniPage from "../../features/common/TerminiCondizioniPage/TerminiCondizioniPage";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import CustomBotIcon from "../../app/assets/custom-icons/CustomBotIcon";
import ChatBotPage from "../../features/common/ChatBotPage/ChatBotPage";
import FolderMacrocat from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/FolderMacrocat";
import FolderExpenseDoc from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/FolderExpenseDoc";
import GestioneDocumentiFolders from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/GestioneDocumentiFolders";
import DocumentiUserPage from "../../features/admin/GestioneDocumentiPage/GestioneDocumentiFolders/Folders/DocumentiUserPage";
import GestionePrompt from "../../features/admin/GestionePrompt/GestionePrompt";
import CustomPromptIcon from "../../app/assets/custom-icons/CustomPromptIcon";
import SettingsChatBot from "../../features/common/ChatBotPage/SettingsChatBot";
import CustomRolesIcon from "../../app/assets/custom-icons/CustomRolesIcon";
import GestioneRuoli from "../../features/admin/GestioneRuoli/GestioneRuoli";

export const generateAdminRoutes = (appConfig) => [
  {
    path: i18n.t("dashboard"),
    name: "dashboard",
    label: i18n.t("Dashboard"),
    order: appConfig?.sectionsOrder?.indexOf("dashboard"),
    isSidebarElement: true,
    isTopbarElement: false,
    element: <DashboardPage />,
    icon: <CustomDashboardIcon className="w-10 h-10" />,
  },
  {
    path: `${i18n.t("manageUsers")}`,
    name: "users",
    label: `${i18n.t("Users")}`,
    order: appConfig?.sectionsOrder?.indexOf("users"),
    isSidebarElement: true,
    isTopbarElement: false,
    element: <GestisciUtentiPage />,
    icon: <CustomManageUsersIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.chat?.general ? `${i18n.t("chat")}` : null,
    name: "chat",
    label: `${i18n.t("Chat")}`,
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("chat"),
    isSidebarElement: appConfig?.modules?.chat?.general,
    isTopbarElement: false,
    element: <ChatPage />,
    icon: <CustomInbox className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.chatBot?.general ? "chat-bot" : null,
    name: "chat-bot",
    label: `${i18n.t("SmartAssistant")}`,
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("chat-bot"),
    isSidebarElement: appConfig?.modules?.chatBot?.general,
    isTopbarElement: false,
    element: <ChatBotPage />,
    icon: <CustomBotIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.chatBot?.settingsBot ? "chat-bot-settings" : null,
    name: "chat-bot-settings",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <SettingsChatBot />,
  },
  {
    path: i18n.t("documentManagement"),
    name: "documents",
    label: i18n.t("Archive"),
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("documents"),
    isSidebarElement: true,
    isTopbarElement: false,
    element: <GestioneDocumentiPage2 />,
    icon: <CustomDocManagementIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.documents?.folders
      ? `${i18n.t("documentManagement")}/folder`
      : null,
    name: "folder-user",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <GestioneDocumentiFolders />,
  },
  {
    path: appConfig?.modules?.documents?.folders
      ? `${i18n.t("documentManagement")}/folder/:id`
      : null,
    name: "folder-category",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <FolderMacrocat />,
  },
  {
    path: appConfig?.modules?.documents?.folders
      ? `${i18n.t("documentManagement")}/folder/:id/documenti`
      : null,
    name: "folder-doc-list",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <FolderExpenseDoc />,
  },
  {
    path: appConfig?.modules?.documents?.folders
      ? `${i18n.t("documentManagement")}/folder/:id/documenti/archivio`
      : null,
    name: "folder-archivio",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <DocumentiUserPage />,
  },
  {
    path: appConfig?.modules?.practice?.general
      ? `${i18n.t("managePractices")}`
      : null,
    name: "practices",
    label: `${i18n.t("Practice")}`,
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("practices"),
    isSidebarElement: appConfig?.modules?.practice?.general,
    isTopbarElement: false,
    element: <GestisciPratichePage />,
    icon: <CustomPaperworkManagementIcon className="w-10 h-10" />,
  },
  {
    path: `${i18n.t("services")}-${i18n.t("studio")}`,
    name: "services",
    label: i18n.t("Services"),
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("services"),
    isSidebarElement: appConfig?.modules?.services?.general,
    isTopbarElement: false,
    element: <ServiziPage />,
    icon: <CustomStudioServicesIcons className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.company?.general
      ? `${i18n.t("manage-company")}`
      : null,
    name: "companies",
    label: `${i18n.t("Companies")}`,
    order: appConfig?.sectionsOrder?.indexOf("companies"),
    isSidebarElement: appConfig?.modules?.company?.general,
    isTopbarElement: false,
    element: <GestioneCompany />,
    icon: <CustomFactoryIcon className="w-10 h-10" />,
  },
  {
    path: `${i18n.t("studios")}`,
    name: "studios",
    label: i18n.t("Studios"),
    order: appConfig?.sectionsOrder?.indexOf("studios"),
    isSidebarElement: true,
    isTopbarElement: false,
    element: <GestisciStudioPage />,
    icon: <CustomStudioManagementIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.news ? i18n.t("manage-news") : null,
    name: "news",
    label: i18n.t("News"),
    order: appConfig?.sectionsOrder?.indexOf("news"),
    isSidebarElement: appConfig?.modules?.news,
    isTopbarElement: false,
    element: <GestioneNews />,
    icon: <CustomNewsIcon className="w-10 h-10" />,
  },

  {
    path: `${i18n.t("operators")}`,
    name: "operators",
    label: `${i18n.t("Operators")}`,
    order: appConfig?.sectionsOrder?.indexOf("operators"),
    isSidebarElement: true,
    isTopbarElement: false,
    element: <GestisciCommercialistiPage />,
    icon: <CustomOperatorIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.calendar ? i18n.t("manage-deadline") : null,
    name: "deadlines",
    label: i18n.t("Deadlines"),
    order: appConfig?.sectionsOrder?.indexOf("deadlines"),
    isSidebarElement: appConfig?.modules?.calendar,
    isTopbarElement: false,
    element: <NotifichePage />,
    icon: <CustomCalendar className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.categories ? `${"extend-doc-categories"}` : null,
    name: "categories",
    label: `${i18n.t("ExtCategoriesShort")}`,
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("categories"),
    isSidebarElement: appConfig?.modules?.categories,
    isTopbarElement: false,
    element: <ExtendDocCategoriesPage />,
    icon: <CustomCategory className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.prompt ? i18n.t("manage-prompt") : null,
    name: "prompt",
    label: "Prompt",
    ai: true,
    order: appConfig?.sectionsOrder?.indexOf("prompt"),
    isSidebarElement: appConfig?.modules?.prompt,
    isTopbarElement: false,
    element: <GestionePrompt />,
    icon: <CustomPromptIcon className="w-10 h-10" />,
  },
  {
    path: appConfig?.modules?.roles ? i18n.t("manage-roles") : null,
    name: "roles",
    label: `${i18n.t("RolesPermitted")}`,
    order: appConfig?.sectionsOrder?.indexOf("roles"),
    isSidebarElement: appConfig?.modules?.roles,
    isTopbarElement: false,
    element: <GestioneRuoli />,
    icon: <CustomRolesIcon className="w-10 h-10" />,
  },
  {
    path: i18n.t("profile"),
    name: i18n.t("profile"),
    label: i18n.t("Profile"),
    isSidebarElement: false,
    isTopbarElement: true,
    element: <ModificaProfiloPage />,
    icon: <PersonRoundedIcon />,
  },
  {
    path: i18n.t("uploadDocuments"),
    name: i18n.t("uploadDocuments"),
    label: i18n.t("UploadDoc"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <CaricaDocumentiPage />,
  },
  {
    path: appConfig?.modules?.practice?.general
      ? `${i18n.t("managePractices")}/:id`
      : null,
    name: `${i18n.t("managePractices")}`,
    label: `${i18n.t("ManagePractices")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <GestisciPratichePage />,
    icon: <CustomPaperworkManagementIcon className="w-10 h-10" />,
  },

  {
    path: `${i18n.t("manageUsers")}/${i18n.t("create")}-${i18n.t("user")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <CreaUtentePage />,
  },
  {
    path: `${i18n.t("operators")}/${i18n.t("create")}-${i18n.t("operator")}`,

    isSidebarElement: false,
    isTopbarElement: false,
    element: <CreaUtentePage />,
  },
  {
    path: appConfig?.modules?.company?.general
      ? i18n.t("create-company")
      : null,
    name: i18n.t("create-company"),
    label: i18n.t("CreateCompany"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <FormCompany isEdit={false} />,
    icon: <CustomFactoryIcon className="w-10 h-10" />,
  },

  {
    path: appConfig?.modules?.company?.general
      ? `${i18n.t("edit-company")}/:id`
      : null,
    name: i18n.t("edit-company"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <SchedaCompany />,
  },

  {
    path: `${i18n.t("studios")}/${i18n.t("createStudioRoute")}`,
    name: `${i18n.t("studios")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <CreaStudio />,
  },

  {
    path: appConfig?.modules?.news ? i18n.t("news") : null,
    name: i18n.t("news"),
    label: i18n.t("News"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <NewsPage />,
    icon: <CustomNewsIcon className="w-10 h-10" />,
  },

  {
    path: appConfig?.modules?.news
      ? `${i18n.t("manage-news")}/${i18n.t("create-news")}`
      : null,
    name: i18n.t("create-news"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <CreaNews />,
  },
  {
    path: appConfig?.modules?.news ? `${i18n.t("manage-news")}/:id` : null,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <CreaNews />,
  },

  {
    path: `${i18n.t("operators")}/:id`,
    name: `${i18n.t("Operators")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <SchedaCommercialista />,
  },
  {
    path: `${i18n.t("studiosRoute")}/:id`,
    name: `${i18n.t("studiosRoute")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <SchedaStudio />,
  },
  {
    path: i18n.t("assistance"),
    name: i18n.t("assistance"),
    isSidebarElement: false,
    isTopbarElement: false,
    element: <AssistenzaPage />,
  },
  {
    path: `${i18n.t("singlePracticeRoute")}/:Id`,
    name: `${i18n.t("singlePracticeRoute")}`,
    isSidebarElement: false,
    isTopbarElement: false,
    element: <SinglePraticaPage />,
  },
  {
    path: `${i18n.t("singlePracticeRoute")}/:Id/${i18n.t("documents")}`,
    name: "documenti",
    isSidebarElement: false,
    isTopbarElement: false,
    element: <DocumentiPage />,
  },

  {
    path: i18n.t("terms-and-conditions"),
    name: "terms",
    label: i18n.t("TermsAndConditions"),
    isSidebarElement: false,
    isTopbarElement: true,
    element: <TerminiCondizioniPage />,
    icon: <ReceiptLongRoundedIcon />,
  },
  {
    path: null,
    name: "privacy",
    label: "Privacy policy",
    isSidebarElement: false,
    isTopbarElement: true,
    icon: <PrivacyTipRoundedIcon />,
  },
];
